// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__9LsDi","upload":"Small_upload__2kYLi","imageWrap":"Small_imageWrap__2frD6","removeBtn":"Small_removeBtn__19EW3"};